import { onMounted, onUnmounted, ref } from 'vue';
import Pusher from 'pusher-js';

export interface PusherMessage {
  raffleId: string;
  ticketNumbers: number[];
}

export function usePusher(channel: string) {
  const pusher = ref<Pusher | null>(null);
  const isConnected = ref(false);
  const latestTickets = ref<PusherMessage | null>(null);

  onMounted(() => {
    const key = import.meta.env.VITE_PUSHER_KEY || 'YOUR_PUSHER_KEY_HERE';
    const cluster = import.meta.env.VITE_PUSHER_CLUSTER || 'mt1';

    console.log('[Pusher] Initializing with key:', key ? `${key.substring(0, 8)}...` : 'NOT_SET');

    try {
      pusher.value = new Pusher(key, {
        cluster,
        forceTLS: true,
      });

      const pusherChannel = pusher.value.subscribe(channel);

      // Listen for tickets sold
      pusherChannel.bind('tickets-sold', (data: PusherMessage) => {
        console.log('[Pusher] Tickets sold:', data);
        latestTickets.value = data;
      });

      // Listen for ticket availability
      pusherChannel.bind('ticket-available', (data: any) => {
        console.log('[Pusher] Ticket available:', data);
      });

      pusher.value.connection.bind('connected', () => {
        console.log('[Pusher] Connected to channel:', channel);
        isConnected.value = true;
      });

      pusher.value.connection.bind('error', (err: any) => {
        console.error('[Pusher] Connection error:', err);
      });
    } catch (error) {
      console.error('[Pusher] Init error:', error);
    }
  });

  onUnmounted(() => {
    if (pusher.value) {
      pusher.value.disconnect();
      isConnected.value = false;
    }
  });

  return {
    isConnected,
    latestTickets,
  };
}
